import { DictContext } from "@/layout/context/DictContext";
import { Select, SelectProps } from "antd";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

type SelectLocationTypePros<T> = Omit<SelectProps<T>, "options">

function SelectLocationType<T>(props: SelectLocationTypePros<T>) {
  const { t } = useTranslation();
  const { locationTypes } = useContext(DictContext);

  return (
    <Select
      {...props}
      options={
        locationTypes.map(type => ({ key: type.key, label: type.desc, value: type.key }))
      }
      placeholder={t('inventory.locationType')}
    />
  )
};

export default SelectLocationType;